import React,{useState,useEffect} from 'react'
import { Button, Form, Segment } from 'semantic-ui-react'
import { Typography } from '@material-ui/core'
import {connect} from 'react-redux';
import { EditVendor,deleteVendor } from '../../Store/Action';
import { withRouter } from 'react-router';
import Errormsg from './Errormsg';

function EditForm(props){
    const  {cName,fullName,email,address,service,number,desc } = props.Dets
    const initialState = {cName,
      fullName,
      email,
      address,
      service,
      number,
      desc 
    }

    const [state, setstate] = useState(initialState)
  
    const [showMessage, setshowMessage] = useState(false)
    
    useEffect(() => {
    props.deleteAction(state)
  
    },[])

   

    const getNewDetails=(e)=>{
      setstate(prevState=>({...prevState,[e.target.name] : e.target.value}))
    }

    const submitDets=()=>{
      if(state.cName==="" || state.fullName==="" || state.service==="" 
      || state.address==="" || state.number === '' ){
        setshowMessage(true)
        setTimeout(() => {
            setshowMessage(false)
        }, 4000);
        return setstate(prevState=>({ ...prevState, error : "All Field must be Filled" }))
    }
    else {
      props.editAction(state,props.history)
    }
  }
    return(
       <div className="mt-5 mb-5 container">
         <Segment className="bg-light">
         <Typography color="textSecondary" className=" mt-3 mb-5" align="center" variant="h4">
           Edit Vendor Details
         </Typography>
      <Form >
          <Form.Field style={{margin : '20px auto'}} width="12" required >
            <label>Company Name</label>
            <input 
            value={state.cName} 
            placeholder='Company Name'
            name="cName"
            onChange={getNewDetails}
            />
          </Form.Field>
          <Form.Field style={{margin : '20px auto'}} width="12" required>
            <label>Full Name</label>
            <input 
            value={state.fullName} 
            placeholder='Full Name' 
            name="fullName"
            onChange={getNewDetails}
            />
          </Form.Field>
          <Form.Field style={{margin : '20px auto'}} width="12" required>
            <label>Email</label>
            <input 
            value={state.email} 
            placeholder='Email' 
            name="email"
            onChange={getNewDetails}
            />
          </Form.Field>
          <Form.Field style={{margin : '20px auto'}} width="12" required>
            <label>Address</label>
            <input 
            value={state.address} 
            placeholder='Address' 
            name="address"
            onChange={getNewDetails}
            />
          </Form.Field>
          <Form.Field style={{margin : '20px auto'}} width="12">
            <label>Description</label>
            <input 
            value={state.desc} 
            placeholder='Service description' 
            name="desc"
            onChange={getNewDetails}
            />
          </Form.Field>
          <Form.Field style={{margin : '20px auto'}} width="12" required>
            <label>Contact Number</label>
            <input 
            value={state.number} 
            placeholder='Contact Number' 
            name="number"
            onChange={getNewDetails}
            />
          </Form.Field>
          <Form.Field align="center" >
          <Button type='submit' onClick={submitDets} color="linkedin" >Submit</Button>
          </Form.Field>
        </Form>
        </Segment>
        {
          (state.error)  ? 
          <Errormsg open={showMessage} msg={state.error}/>
          : 
          ""
        }
       </div>
   
     )
  
}

const mapStateToProps=state=>({
  state_data : state.reducer  
})

const mapDispatchToProps=({
  editAction : EditVendor,
  deleteAction : deleteVendor
})

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditForm))
